import { useEffect } from '../../../src/InBuildImports';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Properties, systemConfiguration, includeScripts, includeBootstrapCss, includeBundleBootstrapCss} from '../../../src/CommonImports';
import './../css/GSideBar.css';
import './../css/Gtop.css';
import './../css/GFooter.css';
import './../css/GPage2.css';
import './../css/GPage3.css';
import './../css/GLayOutSpacing.css';
import './../css/GAnimetion.css';
import './../css/GAboutUs.css';
import 'bootstrap/dist/css/bootstrap.min.css';

function GJobAboutCard() {
    const sasToken = systemConfiguration.AZURE_FTP_GRASTECH3JOBS_SAAS_TOKEN;
    const mediaUrl = 'https://grastechftp.blob.core.windows.net/grastech3jobs/media/icons/';

    useEffect(() => {
        includeBootstrapCss();
        includeBundleBootstrapCss();
        includeScripts();
        document.addEventListener("DOMContentLoaded", function () {
            if (window.innerWidth >= 992) {
                const sidebar = Offcanvas(document.getElementById(Properties.SIDEBAR_MENU_PROP));
                sidebar.show();
            }
        });
    }, []);


    return (
        <div>
        <section className="section-box mt-10">
            <div className="container">
                <div className="row">
                    <div className="col-lg-11 mx-auto">
                        <div className="row pt-5">
                            <div className="col-lg-3 col-md-6 col-sm-6 col-12 mb-md-30">
                                <div className="card-grid-4 hover-up">
                                    <div className="image-top-feature">
                                        <figure><img alt="jobhub" src={mediaUrl+"market-research.svg?"+sasToken}/></figure>
                                    </div>
                                    <div className="card-grid-4-info">
                                        <h5 className="mt-20">Market Research</h5>
                                        <p className="text-normal mt-15 mb-20">It is a long established fact that a reader will be.</p>
                                        <a href="#" className="btn-readmore icon-arrow">Read more</a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-6 col-12 mb-md-30">
                                <div className="card-grid-4 hover-up">
                                    <div className="image-top-feature">
                                        <figure><img alt="jobhub" src={mediaUrl+"creative-layout.svg?"+sasToken}/></figure>
                                    </div>
                                    <div className="card-grid-4-info">
                                        <h5 className="mt-20">Creative Layout</h5>
                                        <p className="text-normal mt-15 mb-20">It is a long established fact that a reader will be.</p>
                                        <a href="#" className="btn-readmore icon-arrow">Read more</a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-6 col-12 mb-md-30">
                                <div className="card-grid-4 hover-up">
                                    <div className="image-top-feature">
                                        <figure><img alt="jobhub" src={mediaUrl+"digital-marketing.svg?"+sasToken}/></figure>
                                    </div>
                                    <div className="card-grid-4-info">
                                        <h5 className="mt-20">Digital Marketing</h5>
                                        <p className="text-normal mt-15 mb-20">It is a long established fact that a reader will be.</p>
                                        <a href="#" className="btn-readmore icon-arrow">Read more</a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                                <div className="card-grid-4 hover-up">
                                    <div className="image-top-feature">
                                        <figure><img alt="jobhub" src={mediaUrl+"seo-backlink.svg?"+sasToken}/></figure>
                                    </div>
                                    <div className="card-grid-4-info">
                                        <h5 className="mt-20">SEO &amp; Backlinks</h5>
                                        <p className="text-normal mt-15 mb-20">It is a long established fact that a reader will be.</p>
                                        <a href="#" className="btn-readmore icon-arrow">Read more</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        </div>
    );
}
export default GJobAboutCard;